import type { ClientDirectoryType } from "@/redux/clientDirectory/clientDirectoryType";

export const clientDirectoryReducer = {
  resetClientDirectoryError: (state: ClientDirectoryType) => {
    state.error = null;
  },
  resetClientDirectoryMessage: (state: ClientDirectoryType) => {
    state.message = null;
  },
  resetClientDirectoryStatusCode: (state: ClientDirectoryType) => {
    state.statusCode = null;
  },
  resetClientDirectorySuccess: (state: ClientDirectoryType) => {
    state.success = null;
  },
  resetClientDirectoryFetching: (state: ClientDirectoryType) => {
    state.fetching = false;
  },
  resetClientDirectoryList: (state: ClientDirectoryType) => {
    state.clientDirectoryList = [];
  },
  resetSingleClientDirectory: (state: ClientDirectoryType) => {
    state.singleClientDirectory = {};
  },
  resetClientDirectoryTotalCount: (state: ClientDirectoryType) => {
    state.totalCount = null;
  },
  resetClientStatusSuccess: (state: ClientDirectoryType) => {
    state.clientStatusSuccess = null;
  },
  resetClientAadharUniqueCheckSuccess: (state: ClientDirectoryType) => {
    state.clientAadharUniqueCheckSuccess = null;
  },
  resetClientAadharUniqueCheckError: (state: ClientDirectoryType) => {
    state.clientAadharUniqueCheckError = null;
  },
  resetClientAadharUniqueCheckMessage: (state: ClientDirectoryType) => {
    state.clientAadharUniqueCheckMessage = null;
  },
  resetClientPanUniqueCheckSuccess: (state: ClientDirectoryType) => {
    state.clientPanUniqueCheckSuccess = null;
  },
  resetClientPanUniqueCheckError: (state: ClientDirectoryType) => {
    state.clientPanUniqueCheckError = null;
  },
  resetClientPanUniqueCheckMessage: (state: ClientDirectoryType) => {
    state.clientPanUniqueCheckMessage = null;
  },
  resetLeadDirectoryTotal: (state: ClientDirectoryType) => {
    state.leadDirectoryTotal = 0;
  },
  resetLeadDirectoryList: (state: ClientDirectoryType) => {
    state.leadDirectoryList = [];
  },
  resetSingleClientLeadDirectoryDetails: (state: ClientDirectoryType) => {
    state.singleClientleadDirectoryDetails = {};
  },
  resetLeadModuleCommentsSuccess: (state: ClientDirectoryType) => {
    state.leadDirectoryCommentsSuccess = null;
  },
  resetLeadModuleCommentsListing: (state: ClientDirectoryType) => {
    state.leadDirectoryCommentsList = [];
  },
  resetLeadDirectoryCommentsFetching: (state: ClientDirectoryType) => {
    state.leadDirectoryCommentsFetching = false;
  },
  resetLeadModuleRecordingsSuccess: (state: ClientDirectoryType) => {
    state.leadDirectoryRecordingsSuccess = null;
  },
  resetLeadModuleRecordingsListing: (state: ClientDirectoryType) => {
    state.leadDirectoryRecordingsList = [];
  },
  resetLeadDirectoryRecordingsFetching: (state: ClientDirectoryType) => {
    state.leadDirectoryRecordingsFetching = false;
  },
  resetLeadHistory: (state: ClientDirectoryType) => {
    state.leadHistory = [];
  },
  resetLeadStageCount: (state: ClientDirectoryType) => {
    state.leadStageCount = [];
  },
  resetLeadClientEmailHistory: (state: ClientDirectoryType) => {
    state.leadClientEmailHistory = [];
  },
  // resetClientEmailHistory: (state: ClientDirectoryType) => {
  //   state.clientEmailHistory = []
  // },
  resetLeadEmailFetching: (state: ClientDirectoryType) => {
    state.emailFetching = false;
  },
  setPersistLeadDirectory: (state: ClientDirectoryType, action: any) => {
    state.persistLeadDirectoryList = action.payload;
  },
  resetClientMeetUpChecklistData: (state: ClientDirectoryType) => {
    state.clientMeetUpChecklistData = [];
  },
  resetSingleClientMeetUpCheklistData: (state: ClientDirectoryType) => {
    state.singleClientMeetUpChecklistData = {};
  },
  resetUniqueCityList: (state: ClientDirectoryType) => {
    state.uniqueCityList = [];
  },
  resetUniqueCityCount: (state: ClientDirectoryType) => {
    state.uniqueCityCount = 0;
  },
  resetCityFetching: (state: ClientDirectoryType) => {
    state.cityFetching = false;
  },
  resetLeadStageList: (state: ClientDirectoryType) => {
    state.leadStageList = [];
  },
  resetLeadStageTotal: (state: ClientDirectoryType) => {
    state.leadStageTotal = 0;
  },
};
